module.exports = " <div> <a v-for=\"course in championship.courses\" @click=selectCourse(course) class=\"btn btn-default\" v-bind:class=\"{'active': course.id == current_course.id }\">{{course.name}}</a> <div class=rondaSelect> <a v-for=\"date in championship.dates | orderBy 'date'\" @click=\"selectDate(date, $index)\" class=\"btn btn-default\" v-bind:class=\"{'active': date.id == current_date.id }\"> Ronda {{ $index + 1}} </a> </div> <players-list></players-list> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/vue-html-loader!/home/onlygamescl/onlygames-front/shared/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Game.vue
 ** module id = 285
 ** module chunks = 1
 **/